import { Components, Theme } from '@mui/material/styles';
import { getFocusRingStyle } from '@/src/components/focusring/focusring';
import { getInteractiveStyle } from '@/src/materialui/button/interactive';
import { flowStepIconClasses } from './StepLabelIcon';

export const flowStepButton: Components<Theme>['MuiStepButton'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: '0',
      margin: '0',
      ...getFocusRingStyle(theme, false, 0, '.Mui-focusVisible .MuiStepLabel-iconContainer'),
      // apply interactive styles on to flowStepIcon when hovered over StepButton
      ...getInteractiveStyle(
        {
          [`& .${flowStepIconClasses.root}`]: {
            // default
            backgroundColor: 'transparent',
            // completed
            [`&.${flowStepIconClasses.completed}:not(.${flowStepIconClasses.active}):not(.${flowStepIconClasses.disabled})`]:
              {
                backgroundColor:
                  theme.palette.mode === 'dark' ? theme.palette.brand.secondary : theme.palette.brand.primary,
              },
            // error
            [`&.${flowStepIconClasses.error}, &.${flowStepIconClasses.error}.${flowStepIconClasses.completed}`]: {
              borderColor: theme.palette.error.main,
              backgroundColor: theme.palette.error.main,
            },
            // active
            [`&.${flowStepIconClasses.active}`]: {
              borderColor: theme.palette.mode === 'dark' ? theme.palette.brand.secondary : theme.palette.brand.primary,
              '&::before': {
                backgroundColor:
                  theme.palette.mode === 'dark' ? theme.palette.brand.secondary : theme.palette.brand.primary,
              },
              [`&.${flowStepIconClasses.error}`]: {
                borderColor: theme.palette.error.main,
                '&::before': {
                  backgroundColor: 'transparent',
                  borderColor: theme.palette.background.primary,
                },
              },
            },
          },
        },
        {
          [`& .${flowStepIconClasses.root}`]: {
            // default
            backgroundColor: theme.palette.surface.secondary,
            // completed
            [`&.${flowStepIconClasses.completed}:not(.${flowStepIconClasses.active})`]: {
              borderColor: theme.palette.onSurface.os700,
              backgroundColor:
                theme.palette.mode === 'dark' ? theme.palette.brand.secondary : theme.palette.brandHover.primary,
            },
            // error
            [`&.${flowStepIconClasses.error}, &.${flowStepIconClasses.error}.${flowStepIconClasses.completed}`]: {
              backgroundColor: theme.palette.error.main,
            },
            // active
            [`&.${flowStepIconClasses.active}`]: {
              borderColor:
                theme.palette.mode === 'dark' ? theme.palette.brand.secondary : theme.palette.brandHover.primary,
              '&::before': {
                backgroundColor:
                  theme.palette.mode === 'dark' ? theme.palette.brand.secondary : theme.palette.brandHover.primary,
              },
              [`&.${flowStepIconClasses.error}`]: {
                borderColor: theme.palette.error.main,
                '&::before': {
                  backgroundColor: 'transparent',
                  borderColor: theme.palette.background.primary,
                },
              },
            },
          },
        },
      ),
    }),
  },
};
